export default __webpack_public_path__ + "static/Group3-0e3b478dc95978c0ea953a0bd710af14.png";